import styled from 'styled-components';

import { useApply } from 'inquiry/lib/jsonLogic';
import { sizeCss } from 'lib/inquiryStyles';
import { SpacerComponent } from 'lib/interfaces/ui-components';
import { Inquiry } from 'verify/models/inquiry';

const SpacerDiv = styled.div.attrs(() => ({ 'aria-hidden': true }))<{
  height: string;
  styles: SpacerComponent['styles'];
}>(({ styles, height }) => ({
  height: sizeCss(styles?.height.base.base) ?? height,
  width: sizeCss(styles?.width.base.base),
  flex: 'none',
}));

interface SpacerProps {
  component: SpacerComponent;
  inquiry: Inquiry;
}

const Spacer = ({ component, inquiry }: SpacerProps) => {
  const { hidden } = component.attributes;

  const apply = useApply(component.name, inquiry.attributes['next-step'].name);
  const isHidden = apply<boolean>(hidden);

  if (isHidden) {
    return null;
  }

  return (
    <SpacerDiv
      data-test={component.type}
      height={component.attributes.height}
      styles={component.styles}
    />
  );
};

export default Spacer;
